import axios from 'axios'
import React, { useState } from 'react'
import authService from '../../../../Components/Login/auth.service'
import '../../../../styles/pages/SubMenuPages/SubMenuTipoDeObservacao/modal-tiposDeobservacoes/modalNovoTipoDeobservacao.css'
//const uuidv4 = require('uuid/v4')

export default function Modal() {
  const uuidv4 = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(16) + '-' + Math.random().toString(16).slice(2);
  var user = authService.getCurrentUser();
  let newDate = new Date()

  const [campos, setCampos] = useState({
    IdObservacaoTipo: '',
    IdEmpresa: user[0].IdEmpresa,
    otpDescricao: '',
    otpFatorPositivo: '',
    otpFatorNegativo: '',
    otpFatorNeutro: '',
    otpPermitirNA: 0,
    otpStatus: 1,
    otpObservacoes: '',
    otpCriadoPor: user[0].pesEmail,
    otpCriadoEm: newDate,
    otpAlteradoPor: user[0].pesEmail,
    otpAlteradoEm: newDate,
    otpCodigoGUID: uuidv4
  })

  function handleInputChange(event) {
    if (event.target.name === 'otpPermitirNA') {
      if (event.target.value === 'on') {
        campos[event.target.name] = 1
      } else {
        campos[event.target.name] = 0
      }
    } else {
      campos[event.target.name] = event.target.value
    }
    setCampos(campos)

    //console.log(campos)
  }

  function handleFormSubmit(event) {
    event.preventDefault()
    axios
      .post(process.env.REACT_APP_API_URL + '/api/v1/observacaotipo', campos)
      .then(response => {
        alert(response.data.message)
        window.location.reload()
      })
  }
  const [modal, setModal] = useState(false)

  const toggleModal = () => {
    setModal(!modal)
  }

  if (modal) {
    document.body.classList.add('active-modal')
  } else {
    document.body.classList.remove('active-modal')
  }

  return (
    <>
      <button onClick={toggleModal} className="buttonModalPadrao">
        Novo Checklist
      </button>

      {modal && (
        <div className="overlay">
          <div className="modalPadrao-content">
            <div className="cxTituloPadrao">
              <h1>
                Novo Checklist
                <hr className="hrTitleModal" />
              </h1>
              <button className="close-modal" onClick={toggleModal}>
                X
              </button>
            </div>

            <form onSubmit={handleFormSubmit}>
              <label>
                Descrição:
              </label>
              <input
                type="text"
                id="otpDescricao"
                name="otpDescricao"
                onChange={handleInputChange}
              ></input>
              <label>
                Fatores para cálculo de resultado final da Auditoria:
              </label>
              <label>
                FÓRMULA: (Total Positivo + Total Negativo + Total Neutro) - Total Negativo.
              </label>
              <div className="linhaTipObs">

                <tr>
                  <th>
                    <label>Positivo:</label>
                  </th>
                  <th>
                    <label>Negativo:</label>
                  </th>
                  <th>
                    <label>Neutro:</label>
                  </th>
                </tr>
                <tr>
                  <td>
                    <label>
                      <input
                        // className="NTOPositivo"
                        placeholder="Nº"
                        type="number"
                        id="otpFatorPositivo"
                        name="otpFatorPositivo"
                        onChange={handleInputChange}
                      ></input>
                    </label>
                  </td>
                  <td>
                    <input
                      // className="NTONegativo"
                      placeholder="Nº"
                      type="number"
                      id="otpFatorNegativo"
                      name="otpFatorNegativo"
                      onChange={handleInputChange}
                    ></input>
                  </td>
                  <td>
                    <input
                      // className="NTONeutro"
                      placeholder="Nº"
                      type="number"
                      id="otpFatorNeutro"
                      name="otpFatorNeutro"
                      onChange={handleInputChange}
                    ></input>
                  </td>
                </tr>
              </div>



              <label>
                Observação:
              </label>
              <textarea
                type="text"
                id="otpObservacoes"
                name="otpObservacoes"
                row="none"
                maxLength="500"
                onChange={handleInputChange}
              ></textarea>

              <div className="caixaSalvarPadrao">
                <div className="InputAuthorization1">
                  <label>
                    <input
                      name="otpPermitirNA"
                      type="checkbox"
                      onChange={handleInputChange}
                      Checked={!!campos.otpPermitirNA}
                    />
                    <span>
                      Permitir resposta NÃO APLICADO no APP
                    </span>
                  </label>
                </div>
                <button type="submit" className="gravar-modal">
                  Salvar Checklist
                </button>
              </div>
            </form>

          </div>
        </div>
      )}
    </>
  )
}
